@if (!isSmeUser) {
  <div class="page-title">Dashboard</div>
}

<div [class.wrapper]="!isSmeUser">
  @if (!isSmeUser) {
    <app-dashboard-pending-actions
      (reviewLeadStatus)="showLeadStatusPopup = true"
    ></app-dashboard-pending-actions>
    @if (hasDashboardTabsAccess) {
      <app-dashboard-deeproots-tabs
        [dashboardMetrics]="dashboardMetrics"
        [isLoading]="isLoadingDashboardMetrics"
        (refreshMetrics)="onRefreshMetrics()"
        (leadsToastMessage)="onLeadsToastMessage($event)"
      ></app-dashboard-deeproots-tabs>
    }
    <app-dashboard-arcgis-maps></app-dashboard-arcgis-maps>
  } @else {
    <app-sme-dashboard></app-sme-dashboard>
  }
</div>

@if (showLeadStatusPopup) {
  <app-update-leads-popup
    [showCloseButton]="true"
    (closed)="showLeadStatusPopup = false"
  >
  </app-update-leads-popup>
}
